/* hcs-qa-picker.js — quick-add variant picker.
   Mobile / touch: bottom sheet (scrim + focus trap). Hover-capable desktop
   (≥750px, hover+fine pointer): anchored popover under the product card,
   opening on hover or click — no scrim, no focus steal on hover.
   Triggered by [data-qap] buttons: hover via this file's own delegated
   mouseover listener; click via each surface's handler branch.
   Reads script[data-qap-data] JSON inside the button's [data-qap-scope]
   (legacy: .hcs-upsell__card). Adds via HCSQuickAdd (stamps _qa_editable,
   re-renders drawer, publishes cartUpdate); also dispatches DOM cart:updated. */
(function () {
  if (window.HCSQaPicker) return;

  var state = null; // { data, picked, scrim?, panel, addBtn, live, opener, onKey, pop, onDoc?, onScroll?, hoverTimer? }
  var popMedia = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');

  function heatKey(optionName, value) {
    if (!/heat/i.test(optionName)) return null;
    return String(value).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function matchVariant(data, picked) {
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i], ok = true;
      for (var a = 0; a < picked.length; a++) {
        if (picked[a] !== null && v.opts[a] !== picked[a]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function valueAvailable(data, picked, ax, value) {
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      if (!v.available || v.opts[ax] !== value) continue;
      var ok = true;
      for (var a = 0; a < picked.length; a++) {
        if (a === ax || picked[a] === null) continue;
        if (v.opts[a] !== picked[a]) { ok = false; break; }
      }
      if (ok) return true;
    }
    return false;
  }

  function fullMatch(data, picked) {
    var v = matchVariant(data, picked);
    return v && v.available && picked.indexOf(null) === -1 ? v : null;
  }

  function refresh() {
    var d = state.data;
    state.panel.querySelectorAll('.hcs-qap__btn').forEach(function (b) {
      var ax = parseInt(b.getAttribute('data-ax'), 10);
      var val = b.getAttribute('data-val');
      var on = state.picked[ax] === val;
      var avail = valueAvailable(d, state.picked, ax, val);
      b.classList.toggle('hcs-qap__btn--on', on);
      b.classList.toggle('hcs-qap__btn--out', !avail);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.disabled = !avail;
    });
    var v = fullMatch(d, state.picked);
    if (v) {
      state.addBtn.disabled = false;
      // Selected options are already visible on the pressed buttons, so the
      // button carries only the action + price (both sheet and popover);
      // the aria-live region keeps the full combo for screen readers.
      state.addBtn.textContent = 'Add to Cart · ' + v.price;
      state.live.textContent = state.picked.join(', ') + ', ' + v.price;
    } else {
      state.addBtn.disabled = true;
      state.addBtn.textContent = 'Unavailable';
      state.live.textContent = 'Selected combination unavailable';
    }
  }

  function findScope(btn) {
    var scope = btn.closest('[data-qap-scope]') || btn.closest('.hcs-upsell__card');
    return scope && scope.querySelector('script[data-qap-data]') ? scope : null;
  }

  function close() {
    if (!state) return;
    var s = state;
    state = null;
    if (s.hoverTimer) clearTimeout(s.hoverTimer);
    if (s.scrim) s.scrim.classList.remove('hcs-qap--open');
    if (s.arrow) s.arrow.classList.remove('hcs-qap--open');
    s.panel.classList.remove('hcs-qap--open');
    document.removeEventListener('keydown', s.onKey);
    if (s.onDoc) document.removeEventListener('click', s.onDoc, true);
    if (s.onScroll) {
      window.removeEventListener('scroll', s.onScroll, true);
      window.removeEventListener('resize', s.onScroll);
    }
    if (!s.pop && window.removeTrapFocus) {
      var focusTarget = document.contains(s.opener) ? s.opener : document.querySelector('cart-drawer .drawer__inner');
      window.removeTrapFocus(focusTarget);
    }
    if (s.pop && s.focusWasInPanel && document.contains(s.opener)) s.opener.focus();
    setTimeout(function () {
      if (s.scrim) s.scrim.remove();
      if (s.arrow) s.arrow.remove();
      s.panel.remove();
    }, 260);
  }

  function positionPop(panel, opener, arrow) {
    // Anchor to the ⊕ button itself (speech-bubble under the circle) — anchoring to the
    // card put the popover a whole tall tile below the pointer on PDP bundle tiles.
    var scope = findScope(opener);
    var b = opener.getBoundingClientRect();
    var sw = scope ? scope.getBoundingClientRect().width : b.width;
    var margin = 8;
    var width = Math.max(320, Math.min(sw, 360));
    var cx = b.left + b.width / 2;
    var left = Math.min(Math.max(cx - width / 2, margin), window.innerWidth - width - margin);
    panel.style.width = width + 'px';
    panel.style.left = Math.round(left) + 'px';
    // measure after width set
    var h = panel.offsetHeight;
    var below = b.bottom + 8;
    var above = below + h + margin > window.innerHeight && b.top - h - 8 > margin;
    var top = above ? b.top - h - 8 : Math.min(below, window.innerHeight - h - margin);
    panel.style.top = Math.round(top) + 'px';
    if (arrow) {
      // caret sits on the panel edge, pointing at the ⊕ — clamp inside the corner radius
      var ax = Math.min(Math.max(cx - 7, left + 14), left + width - 28);
      arrow.style.left = Math.round(ax) + 'px';
      arrow.style.top = Math.round(above ? top + h - 7 : top - 7) + 'px';
      arrow.classList.toggle('hcs-qap-arrow--below', above);
    }
  }

  function open(btn, via) {
    if (state && state.opener === btn) return; // reentry guard (hover then click)
    if (state) close();
    var scope = findScope(btn);
    if (!scope) {
      var vid = btn.getAttribute('data-variant-id');
      if (vid && window.HCSQuickAdd) {
        window.HCSQuickAdd(vid, btn, { openDrawer: false }).then(function (cartState) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartState }));
        });
      }
      return;
    }
    var data;
    try { data = JSON.parse(scope.querySelector('script[data-qap-data]').textContent); } catch (err) { return; }

    var pop = popMedia.matches;

    var defId = parseInt(btn.getAttribute('data-variant-id'), 10);
    var def = null;
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].id === defId) { def = data.variants[i]; break; }
    }
    if (!def) {
      for (var j = 0; j < data.variants.length; j++) {
        if (data.variants[j].available) { def = data.variants[j]; break; }
      }
    }
    var picked = data.options.map(function (_, ax) { return def ? def.opts[ax] : null; });

    var scrim = null;
    if (!pop) {
      scrim = document.createElement('div');
      scrim.className = 'hcs-qap-scrim';
      scrim.addEventListener('click', close);
    }

    var panel = document.createElement('div');
    panel.className = pop ? 'hcs-qap hcs-qap--pop' : 'hcs-qap';
    panel.setAttribute('role', 'dialog');
    if (!pop) panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Choose options for ' + data.title);

    var html = '<div class="hcs-qap__grab" aria-hidden="true"></div>' +
      '<div class="hcs-qap__head">' +
      (data.image ? '<img class="hcs-qap__thumb" src="' + data.image + '" alt="" width="54" height="54">' : '') +
      '<p class="hcs-qap__title"></p>' +
      '<button type="button" class="hcs-qap__close" aria-label="Close">✕</button>' +
      '</div>';
    data.options.forEach(function (opt, ax) {
      html += '<div class="hcs-qap__ax"><span class="hcs-qap__label" id="hcs-qap-l' + ax + '"></span>' +
        '<div class="hcs-qap__opts" role="group" aria-labelledby="hcs-qap-l' + ax + '">';
      opt.values.forEach(function (val) {
        var hk = heatKey(opt.name, val);
        html += '<button type="button" class="hcs-qap__btn" data-ax="' + ax + '">' +
          (hk ? '<span class="hcs-qap__dot" data-heat="' + hk + '" aria-hidden="true"></span>' : '') +
          '<span class="hcs-qap__val"></span><span class="hcs-qap__desc"></span></button>';
      });
      html += '</div></div>';
    });
    html += '<button type="button" class="hcs-qap__add"></button>' +
      '<span class="hcs-qap__live" aria-live="polite" role="status"></span>';
    panel.innerHTML = html;

    panel.querySelector('.hcs-qap__title').textContent = data.title;
    var btns = panel.querySelectorAll('.hcs-qap__btn');
    var bi = 0;
    data.options.forEach(function (opt, ax) {
      panel.querySelector('#hcs-qap-l' + ax).textContent = opt.name;
      opt.values.forEach(function (val, vi) {
        var b = btns[bi++];
        b.setAttribute('data-val', val);
        b.querySelector('.hcs-qap__val').textContent = val;
        var descEl = b.querySelector('.hcs-qap__desc');
        var desc = opt.descs && opt.descs[vi];
        if (desc) {
          descEl.textContent = desc;
        } else {
          descEl.remove();
        }
        b.addEventListener('click', function () {
          if (!state || state.panel !== panel) return;
          state.picked[ax] = val;
          refresh();
        });
      });
    });

    panel.querySelector('.hcs-qap__close').addEventListener('click', close);
    var addBtn = panel.querySelector('.hcs-qap__add');
    addBtn.addEventListener('click', function () {
      if (!state || state.panel !== panel) return;
      var v = fullMatch(state.data, state.picked);
      if (!v || !window.HCSQuickAdd) return;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      window.HCSQuickAdd(v.id, null, { openDrawer: false })
        .then(function (cartState) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartState }));
          close();
        })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = 'Try again';
        });
    });

    function onKey(e) { if (e.key === 'Escape' || e.code === 'Escape') close(); }
    document.addEventListener('keydown', onKey);

    if (scrim) document.body.appendChild(scrim);
    document.body.appendChild(panel);

    // caret pointing at the ⊕ — separate node (panel's overflow-y would clip it)
    var arrow = null;
    if (pop) {
      arrow = document.createElement('div');
      arrow.className = 'hcs-qap-arrow';
      arrow.setAttribute('aria-hidden', 'true');
      document.body.appendChild(arrow);
    }

    state = { data: data, picked: picked, scrim: scrim, panel: panel, arrow: arrow, addBtn: addBtn, live: panel.querySelector('.hcs-qap__live'), opener: btn, onKey: onKey, pop: pop, focusWasInPanel: false };
    refresh();

    if (pop) {
      positionPop(panel, btn, arrow);
      // hover-intent close: leaving both the opener's card and the panel closes after a grace period
      var hoverables = [panel, findScope(btn) || btn];
      function cancelClose() { if (state && state.panel === panel && state.hoverTimer) { clearTimeout(state.hoverTimer); state.hoverTimer = null; } }
      function scheduleClose() {
        if (!state || state.panel !== panel) return;
        cancelClose();
        state.hoverTimer = setTimeout(function () {
          if (state && state.panel === panel && !state.focusWasInPanel) close();
        }, 250);
      }
      hoverables.forEach(function (el) {
        el.addEventListener('mouseenter', cancelClose);
        el.addEventListener('mouseleave', scheduleClose);
      });
      panel.addEventListener('focusin', function () { if (state && state.panel === panel) state.focusWasInPanel = true; });
      // outside click closes (capture so carousel handlers can't swallow it)
      state.onDoc = function (e) {
        if (!state || state.panel !== panel) return;
        if (panel.contains(e.target) || btn.contains(e.target)) return;
        close();
      };
      document.addEventListener('click', state.onDoc, true);
      // any scroll/resize invalidates the anchor — close rather than chase it
      state.onScroll = function (e) {
        if (!state || state.panel !== panel) return;
        if (e && e.target && panel.contains(e.target)) return; // panel's own scrollbar
        close();
      };
      window.addEventListener('scroll', state.onScroll, true);
      window.addEventListener('resize', state.onScroll);
      requestAnimationFrame(function () {
        panel.classList.add('hcs-qap--open');
        if (arrow) arrow.classList.add('hcs-qap--open');
        // keyboard activation (click with no pointer coords) moves focus into the panel
        if (via === 'key') {
          state.focusWasInPanel = true;
          (panel.querySelector('.hcs-qap__btn--on') || addBtn).focus();
        }
      });
    } else {
      requestAnimationFrame(function () {
        scrim.classList.add('hcs-qap--open');
        panel.classList.add('hcs-qap--open');
        if (window.trapFocus) window.trapFocus(panel, panel.querySelector('.hcs-qap__btn--on') || addBtn);
      });
    }
  }

  // Sitewide hover-open on hover-capable desktop: any [data-qap] button.
  document.addEventListener('mouseover', function (e) {
    if (!popMedia.matches) return;
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-qap]');
    if (!btn) return;
    if (state && state.opener === btn) return;
    open(btn, 'hover');
  });

  window.HCSQaPicker = {
    open: function (btn, e) {
      // detail===0 => keyboard-activated click
      var via = e && typeof e.detail === 'number' && e.detail === 0 ? 'key' : 'click';
      open(btn, via);
    },
    close: close
  };
})();
